export { drain } from "./drain.ts";
